export const CONTENT_TYPES = {
  INCOMING_EMAIL: 'incoming_email',
  GIFT_CARD: 'gift_card',
  BANK_ACCOUNT: 'bank_account',
};
